module.exports = "data:text/x-markdown;base64,V2VsbCBkb25lISBOZXh0LCB0cnkgeW91ciBoYW5kIHdpdGggdGhlIHNlY29uZCBnYXRla2VlcGVyLi4u"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/gatekeeper1_complete.md
// module id = 1382
// module chunks = 0